import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { globalVar } from '../shared/global_variables';
import { WORKSTOCK } from '../workstock/workstock.service';
import { DWSM_JOB } from '../dwsm/services/dwsm-job.service';

export const GET_WORKSTOCK_COUNTER = '/getUserWorkstockCounter';

export const GET_DWSM_COUNTER = '/getUserDWSMCounter';

@Injectable()
export class NavigationService {
    constructor(private http: HttpClient) {}

    public getWorkstockCounter(): Observable<number> {
        return this.http.get<number>(environment.baseUrl + globalVar.requestPrefix + WORKSTOCK + GET_WORKSTOCK_COUNTER);
    }

    public getDWSMCounter(): Observable<number> {
        return this.http.get<number>(environment.baseUrl + globalVar.requestPrefix + DWSM_JOB + GET_DWSM_COUNTER);
    }
}
